<template>
    <el-container>
        <el-header style="height: auto">
            <el-form @submit.native.prevent :inline="true" :model="fromLog" ref="fromLog" :label-width="fontsize" class="demo-form-inline" :rules="rules">
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.OPERATE_TIME')" prop="startTime">
                            <td-date-time v-model="fromLog.startTime" type="datetime" :placeholder="$t('common.START_TIME')" :pickerOptions="pickerBeginDateBefore"></td-date-time>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.UNTIL')" prop="endTime">
                            <td-date-time v-model="fromLog.endTime" type="datetime" :placeholder="$t('common.END_TIME')" :pickerOptions="pickerBeginDateAfter"></td-date-time>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.RES_TYPE')" prop="sResTypeId">
                            <td-select v-model="fromLog.sResTypeId" :options="resOptions" keys="value" text="label" :multiple="multiple" :collapse-tags="collapse" @change="changeRes"></td-select>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.OPERATION_LEVEL')" prop="sOperationLevel">
                            <td-select v-model="fromLog.sLevel" :options="levelOptions" keys="value" text="label" :multiple="multiple" :collapse-tags="collapse" @change="changeLevel"></td-select>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.OPERATE_TYPE')" prop="sOperationType">
                            <td-select v-model="fromLog.sType" :options="options" keys="value" text="label" :multiple="multiple" :collapse-tags="collapse" @change="changeOpeType"></td-select>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.USER')" prop="sUserId" v-if="sUserTree">
                            <td-tree-select
                                ref="TdUserTree"
                                :treeList="userList"
                                :lazyloading="lazyloading"
                                :defaultProps="defaultProps"
                                :isSingleCheck="isSingleCheck"
                                @queryData="queryUserTreeData"
                                @querySearchData="queryUserSearchData"
                                :checkStrictly="false"
                                :inputShow="inputShow"
                                :nodeKey="nodeKey"
                                :multiple="multiple"
                                :params="userParams"
                                :isPaging="true"
                                :filter="userTreeFilter"
                                v-model="fromLog.sUserIds"
                                :imgloading="true"
                            ></td-tree-select>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.USER')" prop="sSelectUser" v-if="sUserSelector">
                            <td-select v-model="fromLog.userId" keys="userId" text="userName" :url="url" :isPage="true" :urlParam="urlParam" :pageSize="pageSize" requestType="POST"></td-select>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item v-show="false" :label="$t('common.DEVICE')" prop="sDeviceId" v-if="sDeviceTree">
                            <td-tree-select
                                ref="TdTree"
                                :treeList="treeList"
                                :lazyloading="lazyloading"
                                :defaultProps="defaultProps"
                                :isSingleCheck="isSingleCheck"
                                @queryData="queryDevTreeData"
                                @querySearchData="querySearchData"
                                :inputShow="inputShow"
                                :nodeKey="nodeKey"
                                :multiple="multiple"
                                :checkStrictly="false"
                                :isPaging="true"
                                :filter="deviceTreeFilter"
                                :params="params"
                                v-model="fromLog.sDevIds"
                                :imgloading="true"
                            ></td-tree-select>
                        </el-form-item>
                    </div>
                </td-permission>
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.DESCRIPTION')" prop="sOperationDescribe">
                            <td-input v-model="fromLog.sOperationDescribe"></td-input>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :loading="loading" @click="btnClickQuery" :permissions="permissionsQuery">{{ $t('common.QUERY') }}</td-button>
                    <td-button type="button" :loading="exportLoading" @click="btnExport" :permissions="permissionsExport">{{ $t('common.EXPORT') }}</td-button>
                </el-form-item>
            </el-form>
            <el-tag type="success" solt="dataTips" style="float:right;" v-show="showMaxLimit"
                >{{ $t('common.DATA_COUNT') }}{{ totalCount }}{{ $t('common.NUMBER_COUNT') }},{{ $t('common.CURRENT_COUNT') }}{{ currentCount }}{{ $t('common.NUMBER_COUNT') }}</el-tag
            >
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :type="index"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :rowKey="rowKey"
                :total="total"
                ref="listQueryInfo"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :hasLoading="loading"
                :hasMutiSelect="false"
            ></td-table>
            <dialog-Info
                v-if="dialogInfoVisible"
                :isAddData="isAddData"
                :dialogInfoVisible="dialogInfoVisible"
                :showItem="showItem"
                :title="title"
                @logInfoDialogClose="logInfoDialogClose"
            ></dialog-Info>
        </el-main>
    </el-container>
</template>

<script>
import dialogInfo from './components/dialogInfo.vue';
import queryApi from './assets/api.js';

export default {
    // 初始化渲染
    components: {
        'dialog-Info': dialogInfo
    },
    props: {
        // 树形节点类型
        orgTypeIds: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery(); // 进行页面初始化数据的加载
        let operationTypeParam = {
            sLogSysId: ''
        };
        queryApi.getAllOperationType(JSON.stringify(operationTypeParam), response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                this.$log.error('logTypeManager/getAllOperationLevel', response);
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('logTypeManager/getAllOperationType', response.data.statusMessage);
                return;
            }
            let typeList = response.data.content;
            this.options = [
                {
                    value: 'all',
                    label: this.$t('common.ALL')
                }
            ];
            if (typeList) {
                for (let i = 0; i < typeList.length; i++) {
                    let temValue = typeList[i];
                    let item = {
                        value: temValue.sId,
                        label: temValue.sCaption
                    };
                    this.options.push(item);
                }
            }
        });
        queryApi.getAllOperationLevel(null, response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                this.$log.error('logTypeManager/getAllOperationLevel', response);
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('logTypeManager/getAllOperationType', response.data.statusMessage);
                return;
            }
            let typeList = response.data.content;
            this.levelOptions = [
                {
                    value: 'all',
                    label: this.$t('common.ALL')
                }
            ];
            if (typeList) {
                for (let i = 0; i < typeList.length; i++) {
                    let temValue = typeList[i];
                    let item = {
                        value: temValue.sId,
                        label: temValue.sCaption
                    };
                    this.levelOptions.push(item);
                }
            }
        });
        let allResTypeParam = { logSysId: '' };
        queryApi.getAllResType(allResTypeParam, response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                this.$log.error('logTypeManager/getAllResType', response);
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('logTypeManager/getAllResType', response.data.statusMessage);
                return;
            }
            let typeList = response.data.content;
            this.resOptions = [
                {
                    value: 'all',
                    label: this.$t('common.ALL')
                }
            ];
            if (typeList) {
                for (let i = 0; i < typeList.length; i++) {
                    let temValue = typeList[i];
                    let item = {
                        value: temValue.sId,
                        label: temValue.sName
                    };
                    this.resOptions.push(item);
                }
            }
        });
        let queryCountParam = { str: 'maxCountLimit' };
        queryApi.getMaxLimitCount(queryCountParam, response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                this.$log.error('logTypeManager/getMaxLimitCount', response);
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('logTypeManager/getMaxLimitCount', response.data.statusMessage);
                return;
            }
            let limitCount = parseInt(response.data.content);
            this.maxLimitCount = limitCount === limitCount ? (limitCount > 100 ? limitCount : 100) : 100000;
        });
        let queryExportCountParam = { str: 'maxExportLimit' };
        queryApi.getMaxLimitCount(queryExportCountParam, response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                this.$log.error('logTypeManager/getMaxLimitCount', response);
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('logTypeManager/getMaxLimitCount', response.data.statusMessage);
                return;
            }
            let limitCount = parseInt(response.data.content);
            this.maxLimitExportCount = limitCount === limitCount ? (limitCount > 100 ? limitCount : 100) : 100000;
        });
        queryApi.getOrgTypes(null, response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('getOrgTypes', response.data.statusMessage);
                return;
            }
            let typeList = response.data.content;
            if (typeList) {
                for (let i = 0; i < typeList.length; i++) {
                    let temValue = typeList[i];
                    let userItem = {
                        value: temValue.id,
                        field: 'typeId'
                    };
                    this.userTreeFilter.push(userItem);
                    let deviceItem = {
                        value: temValue.id.toString(),
                        field: 'typeId'
                    };
                    this.deviceTreeFilter.push(deviceItem);
                }
            }
        });
    },
    //监听字体大小
    computed: {
        fontsize() {
            //当页面字体变化时，返回不同宽度
            let widthMap = new Map([
                [14, '80'],
                [16, '90'],
                [18, '100'],
                [20, '110']
            ]);
            return widthMap.get(window.vue.$store.state.fontSize) ? widthMap.get(window.vue.$store.state.fontSize) + 'px' : '';
        }
    },
    // 监听时间
    watch: {
        ['fromLog.startTime'](val) {
            let dateVal = this.fromLog.endTime;
            if (dateVal && val && new Date(val).getTime() > new Date(dateVal).getTime()) {
                this.fromLog.endTime = val;
            }
        },
        ['fromLog.endTime'](val) {
            let dateVal = this.fromLog.startTime;
            if (dateVal && val && new Date(dateVal).getTime() > new Date(val).getTime()) {
                this.fromLog.startTime = val;
            }
        }
    },
    // 定义数据
    data() {
        return {
            index: 'index',
            permissionsQuery: ['operationLog:view'],
            permissionsExport: ['operationLog:export'],
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            isSingleCheck: false,
            multiple: true,
            inputShow: true,
            nodekey: 'id',
            rowKey: 'sId',
            levelOptions: [],
            options: [],
            resOptions: [],
            userOptions: [],
            userList: [],
            collapse: true,
            sUserTree: true,
            sUserSelector: false,
            sDeviceTree: true,
            fromLog: {
                sOperationDescribe: '',
                sDeviceId: '',
                startTime: new Date(Date.parse((this.getNowDate() + ' 00:00:00').replace(/-/g, '/'))),
                endTime: new Date(Date.parse((this.getNowDate() + ' 23:59:59').replace(/-/g, '/'))),
                sUserIds: [],
                sDevIds: [],
                userId: ''
            },

            labelPosition: 'right',
            lazyloading: true,
            treeList: [],
            editItem: '',
            listMqInfo: [],
            tableData: [],
            dialogInfoVisible: false, // 详情
            hasIndex: true,
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false,
            exportLoading: false,
            showOverflowTooltip: true,
            maxLimitCount: 100000,
            maxLimitExportCount: null,
            totalCount: 0,
            currentCount: 0,
            showMaxLimit: false,
            userTreeFilter: [],
            params: {
                pageSize: 50,
                currentPage: 1,
                parentId: ''
            },
            userParams: {
                pageSize: 50,
                currentPage: 1,
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                deviceTypeList: this.parentDevType
            },
            deviceTreeFilter: [],
            // 对表单进行数据验证
            rules: {
                sOperationDescribe: [{ pattern: this.$regex.SQL_CODE, message: this.$t('error.ERROR_CQL_ILLEGAL') }],
                startTime: [{ required: true, message: this.$t('logError.PLEASE_SELECT_STARTTIME'), trigger: 'change' }],
                endTime: [{ required: true, message: this.$t('logError.PLEASE_SELECT_ENDTIME'), trigger: 'change' }]
            },
            url: '/auth/user/getUserInfos',
            urlParam: {
                sSysFlg: this.$common.systemInfo.systemId
            },
            columns: [
                {
                    prop: 'sResTypeCaption',
                    label: 'common.RES_TYPE',
                    align: 'left'
                },
                {
                    prop: 'sOperationTypeCaption',
                    label: 'common.OPERATE_TYPE',
                    align: 'left'
                },

                {
                    prop: 'sOperationLevelCaption',
                    label: 'common.OPERATION_LEVEL',
                    align: 'left'
                },
                {
                    prop: 'dtTime',
                    label: 'common.OPERATE_TIME',
                    align: 'center',
                    tableWidth: '220'
                },
                {
                    prop: 'sOperationUserName',
                    label: 'common.OPERATE_USER',
                    align: 'left'
                },
                {
                    prop: 'sClientIp',
                    label: 'common.OPERATE_CLIETN',
                    align: 'center'
                },
                {
                    prop: 'sOperationDescribe',
                    label: 'common.DESCRIPTION',
                    align: 'left',
                    tableWidth: '400',
                    showOverflowTooltip: true
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    align: 'center',
                    tableWidth: '100',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnShowDetail(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DETAIL')
                            )
                        ]);
                    }
                }
            ],
            pickerBeginDateBefore: {
                disabledDate: time => {
                    let dateVal = this.fromLog.endTime;
                    if (dateVal) {
                        return time.getTime() > new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime();
                    }
                }
            },
            pickerBeginDateAfter: {
                disabledDate: time => {
                    let dateVal = this.fromLog.startTime;
                    if (dateVal) {
                        return time.getTime() <= new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime() - 8.64e7;
                    }
                }
            }
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnClickQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        // 点击查询按钮查询
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.$refs['fromLog'].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let param = this.getParam();
                    queryApi.queryOperationLog(JSON.stringify(param), response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.loading = false;
                            this.$log.error('logQueryManager/queryOperationLog', response);
                            return;
                        }
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('logQueryManager/queryOperationLog', response.data.statusMessage);
                            this.loading = false;
                            return;
                        }
                        this.tableData = response.data.content;
                        if (this.tableData.length > 0) {
                            this.tableData.forEach(item => {
                                item.sDescribe = item.sOperationDescribe;
                                item.sOperationDescribe = this.logFormatter(item.sOperationDescribe);
                            });
                        }
                        this.totalCount = response.data.count;
                        if (this.maxLimitCount && response.data.count >= this.maxLimitCount) {
                            this.total = this.maxLimitCount;
                            this.showMaxLimit = true;
                            this.$refs['listQueryInfo']._initTableHeight();
                        } else {
                            this.total = response.data.count;
                            this.showMaxLimit = false;
                            this.$refs['listQueryInfo']._initTableHeight();
                        }
                        this.currentCount = this.total;
                        this.loading = false;
                    });
                }
            });
        },
        // 格式化显示日志描述
        logFormatter(cellValue) {
            if (cellValue.length > 200) {
                cellValue = cellValue.slice(0, 200) + '...';
            }
            return cellValue;
        },
        // 导出
        btnExport() {
            this.$refs['fromLog'].validate(valid => {
                if (valid) {
                    let param = this.getParam();
                    this.exportLoading = true;
                    queryApi.queryOperationLog(JSON.stringify(param), response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            return;
                        }
                        this.exportLoading = false;
                        if (response.data.count > this.maxLimitExportCount) {
                            this.$confirm(
                                this.$t('common.DATA_COUNT') +
                                    response.data.count +
                                    this.$t('common.NUMBER_COUNT') +
                                    this.$t('common.EXPORT_COUNT') +
                                    this.maxLimitExportCount +
                                    this.$t('common.NUMBER_COUNT') +
                                    this.$t('common.EXPORT_PROCEED'),
                                this.$t('common.TIPS'),
                                {
                                    cancelButtonText: this.$t('common.CANCEL'),
                                    confirmButtonText: this.$t('common.SURE'),
                                    type: 'warning'
                                }
                            )
                                .then(() => {
                                    this.btnExportContent();
                                })
                                .catch(() => {});
                        } else {
                            this.btnExportContent();
                        }
                    });
                }
            });
        },
        // 导出
        btnExportContent() {
            this.exportLoading = true;
            let param = this.getParam();
            let responseType = 'arraybuffer';
            queryApi.exportOperationLog(param, responseType, response => {
                this.exportLoading = false;
                let _response = response;
                try {
                    _response = JSON.parse(this.decodeUTF8(new Uint8Array(response.data)));
                    if (_response.statusCode) {
                        if (_response.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: _response.statusMessage, type: 'error' });
                            return;
                        }
                    }
                } catch (e) {
                    //返回类型不是json说明调用成功，直接导出文件
                }

                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('logTypeManager/exportOperationLog', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('logTypeManager/exportOperationLog', response.data.statusMessage);
                    return;
                }
                this.$log.info('exportOperationLog response ', response);
                let blob = new Blob([response.data], { type: 'application/x-xls' });
                this.content = response.data;
                // 汉子解码
                let filename = decodeURIComponent(response.headers['filename']);
                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
            });
        },
        //获取查询导出参数
        getParam() {
            let param = {
                sCaption: this.fromLog.sName,
                sOperationTypeIds: this.fromLog.sType,
                sOperationLevelIds: this.fromLog.sLevel,
                sResTypeIds: this.fromLog.sResTypeId,
                sOperationDescribe: this.fromLog.sOperationDescribe,
                startTime: this.fromLog.startTime,
                endTime: this.fromLog.endTime,
                //sLogSysId: window.app.sPlatformFlg,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true,
                userId: sessionStorage.getItem('userId')
            };
            if (this.fromLog.sType && this.fromLog.sType.indexOf('all') > -1) {
                param.sOperationTypeIds = null;
            }
            if (this.fromLog.sLevel && this.fromLog.sLevel.indexOf('all') > -1) {
                param.sOperationLevelIds = null;
            }
            if (this.fromLog.sResTypeId && this.fromLog.sResTypeId.indexOf('all') > -1) {
                param.sResTypeIds = null;
            }
            let node = this.fromLog.sDevIds;
            if (node) {
                param.sOperationDevIds = [];
                node.forEach(element => {
                    param.sOperationDevIds.push(element.sId);
                });
            }
            if (this.sUserTree) {
                let userNode = this.fromLog.sUserIds;
                if (userNode) {
                    param.sOperationUserIds = [];
                    userNode.forEach(element => {
                        if (element.sId == '') {
                            param.sOperationUserIds.push(element.id);
                        } else {
                            param.sOperationUserIds.push(element.sId);
                        }
                    });
                }
            } else {
                if (this.fromLog.userId && this.fromLog.userId.indexOf('all') > -1) {
                    param.sOperationUserIds = null;
                } else {
                    param.sOperationUserIds = this.fromLog.userId;
                }
            }
            return param;
        },
        // 详情
        btnShowDetail(row) {
            this.showItem = row;
            this.dialogInfoVisible = true;
            this.title = this.$t('common.DETAIL');
        },

        // 组件关闭需要调用的方法
        logInfoDialogClose() {
            this.dialogInfoVisible = false;
        },
        // 树形数据
        queryTreeData(item) {
            if (item !== null && item.caption !== '' && item.caption !== undefined) {
                this.querySearchData(item);
            } else {
                this.queryDevTreeData(item);
            }
        },
        // 根据设备名称获取设备
        querySearchData: function(item) {
            let queryParam = {
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                caption: item.caption
            };
            let _this = this;
            queryApi.findDeviceTreeByName(JSON.stringify(queryParam), response => {
                if (response.status === _this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === _this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content === null || response.data.content === undefined) {
                            return;
                        }
                        // 初始化树形数据
                        _this.$refs.TdTree.initData(response.data.content);
                    } else {
                        _this.$log.error('/OrgManagerController/findTree', response.data.statusMessage);
                    }
                } else if (response.status === _this.$common.login.RESPONSE_NOT_FOUNR_STATUS) {
                    _this.sDeviceTree = false;
                }
            });
        },

        // 获取组织树形
        queryDevTreeData: function(item) {
            if (item.parentId === '' || item.parentId === null || item.parentId === undefined) {
                item.parentId = '';
                item.includeSelf = true;
            } else {
                item.includeSelf = false;
            }
            let queryParam = {
                includeSelf: item.includeSelf,
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                currentPage: item.currentPage,
                pageSize: item.pageSize
            };
            let _this = this;
            queryApi.findTree(JSON.stringify(queryParam), response => {
                if (response.status === _this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === _this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content === null || response.data.content === undefined) {
                            return;
                        }
                        // 初始化树形数据
                        _this.$refs.TdTree.initData(response.data.content);
                    } else {
                        _this.$log.error('/OrgManagerController/findTree', response.data.statusMessage);
                    }
                } else if (response.status === _this.$common.login.RESPONSE_NOT_FOUNR_STATUS) {
                    _this.sDeviceTree = false;
                }
            });
        },
        // 获取用户组织树形
        queryUserTreeData: function(item) {
            if (item.parentId === '' || item.parentId === null || item.parentId === undefined) {
                item.parentId = item.parentId = '';
            }
            let queryParam = {
                includeSelf: true,
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                sysId: this.$common.systemInfo.systemId,
                needPage: true
            };
            let _this = this;
            queryApi.findUserTree(JSON.stringify(queryParam), response => {
                if (response.status === _this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === _this.$common.requestCode.SUCCESS_INFO_CODE) {
                        _this.sUserTree = true;
                        _this.sUserSelector = false;
                        if (response.data.content === null || response.data.content === undefined) {
                            return;
                        }
                        // 初始化树形数据
                        _this.$refs.TdUserTree.initData(response.data.content);
                    } else {
                        _this.$log.error('/OrgManagerController/findTree', response.data.statusMessage);
                    }
                } else {
                    _this.sUserTree = false;
                    _this.sUserSelector = true;
                    _this.$log.error('/OrgManagerController/findTree', response);
                }
            });
        },
        // 根据用户名称获取用户
        queryUserSearchData: function(item) {
            let queryParam = {
                includeSelf: true,
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                sysId: this.$common.systemInfo.systemId,
                caption: item.caption,
                needPage: true
            };
            let _this = this;
            queryApi.findUserTreeByName(JSON.stringify(queryParam), response => {
                if (response.status === _this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === _this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content === null || response.data.content === undefined) {
                            return;
                        }
                        // 初始化树形数据
                        _this.$refs.TdUserTree.initData(response.data.content);
                    } else {
                        _this.$log.error('/logTypeManager/queryUserSearchData', response.data.statusMessage);
                    }
                } else {
                    _this.$message({ showClose: true, message: this.$t('common.OPERATION_FAIL'), type: 'error' });
                    _this.$log.error('/logTypeManager/queryUserSearchData', response);
                }
            });
        },
        // 获取下拉列表用户
        queryUserSelectData: function() {
            let queryParam = {
                sysId: this.$common.systemInfo.systemId
            };
            queryApi.getAllUsers(JSON.stringify(queryParam), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('logTypeManager/getAllUsers', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('logTypeManager/getAllUsers', response.data.statusMessage);
                    return;
                }
                let userList = response.data.content;
                this.userOptions = [
                    {
                        value: 'all',
                        label: this.$t('common.ALL')
                    }
                ];
                if (userList) {
                    for (let i = 0; i < userList.length; i++) {
                        let temValue = userList[i];
                        let item = {
                            value: temValue.S_ID,
                            label: temValue.S_NAME
                        };
                        this.userOptions.push(item);
                    }
                }
            });
        },
        //资源类型变化事件监听
        changeRes: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.fromLog.sResTypeId = data;
                    } else {
                        this.fromLog.sResTypeId = ['all'];
                    }
                }
            });
        },
        //获取当前日期
        getNowDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return year + '-' + month + '-' + day;
        },
        //操作级别变化事件监听
        changeLevel: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.fromLog.sLevel = data;
                    } else {
                        this.fromLog.sLevel = ['all'];
                    }
                }
                let param = {
                    sOperationLevelIds: this.fromLog.sLevel
                };
                if (this.fromLog.sLevel && this.fromLog.sLevel.indexOf('all') > -1) {
                    param.sOperationLevelIds = null;
                }
                queryApi.getAllOperationType(JSON.stringify(param), response => {
                    if (response.status !== this.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        return;
                    }
                    let typeList = response.data.content;
                    this.fromLog.sType = [];
                    this.options = [
                        {
                            value: 'all',
                            label: this.$t('common.ALL')
                        }
                    ];
                    if (typeList) {
                        for (let i = 0; i < typeList.length; i++) {
                            let temValue = typeList[i];
                            let item = {
                                value: temValue.sId,
                                label: temValue.sCaption
                            };
                            this.options.push(item);
                        }
                    }
                });
            });
        },
        //操作类型变化事件监听
        changeOpeType: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.fromLog.sType = data;
                    } else {
                        this.fromLog.sType = ['all'];
                    }
                }
            });
        },
        //用户变化事件监听
        changeUser: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.fromLog.userId = data;
                    } else {
                        this.fromLog.userId = ['all'];
                    }
                }
            });
        },
        decodeUTF8(arr) {
            var str = '';
            for (var i = 0; i < arr.length; i++) {
                str += String.fromCharCode(arr[i]);
            }
            return decodeURIComponent(escape(str));
        }
    }
};
</script>
<style scoped>
/* .el-form {
    padding-top: 0px;
    margin-bottom: 20px;
} */
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
